import React from 'react';

export type ManelPose = 1 | 2 | 3 | 4 | 5 | 6 | 7;

interface ManelMascotProps {
  /**
   * Pose index from 1 to 7
   * 1: Crossed arms (smiling - Teal shirt)
   * 2: Saluting/Hats off (Green shirt)
   * 3: Winking with arms open (Red shirt)
   * 4: Laughing/Pointing (Blue shirt)
   * 5: Hands on hips (determined - Yellow shirt)
   * 6: Thumbs up (Grey shirt)
   * 7: Fishing with rod (Blue shirt)
   */
  pose?: ManelPose;
  /** Use the version with 'Nossa Pesca' branding on the shirt */
  branded?: boolean;
  /** Width of the mascot */
  width?: number | string;
  /** Optional CSS class */
  className?: string;
  /** Optional click handler */
  onClick?: () => void;
  /** Tooltip or alt text */
  alt?: string;
}

const ManelMascot: React.FC<ManelMascotProps> = ({
  pose = 1,
  branded = true,
  width = 150,
  className = '',
  onClick,
  alt = "Manél - Seu assistente de pesca"
}) => {
  const prefix = branded ? 'branded' : 'original';
  const src = `/assets/manel/${prefix}-pose-${pose}.png`;

  return (
    <div 
      className={`manel-mascot-container inline-block transition-transform duration-300 hover:scale-105 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      <img
        src={src}
        alt={alt}
        style={{ 
          width: typeof width === 'number' ? `${width}px` : width, 
          height: 'auto',
          mixBlendMode: 'multiply',
          filter: 'brightness(1.1) contrast(1.1)'
        }}
        className="block"
      />
    </div>
  );
};

export default ManelMascot;
